import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3bacb6',
        secondary: '#34495e',
        accent: '#e67e22',
      },
    },
  },
});